module.exports = {
  "productApprovalsInteraction": {
    "name": "product-approvals-interaction",
    "class": "interaction",
    "properties": {
      "app": {
        "type": "string",
        "isOptional": true
      },
      "interaction": "string",
      "type": "string",
      "approvalId": {
        "type": "number",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "isSkipped": {
        "type": "boolean",
        "isOptional": true
      },
      "complete": {
        "type": "boolean",
        "isOptional": true
      },
      "enabled": {
        "type": "boolean",
        "isOptional": true
      },
      "rules": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "product-approvals"
  }
};